'use client'

import React, { createContext, useContext, useMemo } from 'react'

const defaultTheme = {
  colors: {
    primary: '#001A33',
    secondary: '#F5F5F5',
  },
  typography: {
    h1Align: 'center',
  },
  slider: {
    desktop: 4,
    mobile: 1.5,
  },
}

const ThemeContext = createContext(defaultTheme)

export const useTheme = () => useContext(ThemeContext)

export const ThemeProvider = ({ children, theme = {} }) => {
  const mergedTheme = useMemo(() => {
    return {
      ...defaultTheme,
      ...theme,
      colors: {
        ...defaultTheme.colors,
        ...(theme.colors || {}),
      },
      typography: {
        ...defaultTheme.typography,
        ...(theme.typography || {}),
      },
      propertySlider: {
        ...defaultTheme.propertySlider,
        ...(theme.propertySlider || {}),
      },
    }
  }, [theme])

  return (
    <ThemeContext.Provider value={mergedTheme}>
      <div
        style={{
          '--primary-color': mergedTheme.colors.primary,
          '--secondary-color': mergedTheme.colors.secondary,
          '--h1-align': mergedTheme.typography.h1Align,
        }}
      >
        {children}
      </div>
    </ThemeContext.Provider>
  )
}
